import {
	InputAdornment,
	Stack,
	TextField,
	Typography
} from "@mui/material";
import { Box } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import passwordIcon from "../../../Assets/Icons/PasswordFieldIcon.svg";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { ApiContext } from "../../ApiContext";
import BigButton from "../../Common/BigButton";
import { Spinner } from "../../Common/Spinner";

export const ManagePassword = () => {
	function regex(type, value) {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const phoneRegex = /^\+\d{1,}$/;
		const licenseRegex = /^[A-Z]{3}-[0-9]{3}$/;
		const nameRegex = /^[a-zA-Z\säöüÄÖÜß]*$/; // Modified regex to include umlaut characters

		switch (type) {
			case "password":
				if (value.length === 0) return false;
				return value.length <= 6;
			case "email":
				if (value.length === 0) return false;

				return !emailRegex.test(value);
			case "phone":
				if (value.length === 0) return false;

				return !phoneRegex.test(value);
			case "license_plate":
				if (value.length === 0) return false;

				return !licenseRegex.test(value);
			case "name":
				return !nameRegex.test(value);
			default:
				return false;
		}
	}

	const { ApiCall } = useContext(ApiContext);

	const [userData, setUserData] = useState({});
	const [saving, setSaving] = useState(false);

	const { t } = useTranslation();
	const [newPass, setNewPass] = useState("");
	const [loading, setLoading] = useState(true);

	function modifyUserData(type, value) {
		let tempUser = { ...userData };
		tempUser[type] = value;

		// console.log(tempUser);

		setUserData(tempUser);
	}

	const HandleUpdate = () => {

		setSaving(true);

		if (regex("password", newPass) ||
			regex("name", userData.name) ||
			regex("phone", userData.phone) ||
			regex("license_plate", userData.license_plate)) 
			return;

		let body = {
			language: userData.language,
			name: userData.name,
			phone: userData.phone,
			license_plate: userData.license_plate
		};

		if (newPass.length > 6) {
			body.password = newPass;
		}

		ApiCall("PUT", `user`, body)
			.then(() => {
				setSaving(false);
				window.location.reload(false);
			})
			.catch((error) => {
				console.log(error);
				setSaving(false);
			});
	};

	function fetchUser() {
		setLoading(true);
		ApiCall("GET", "user", null)
			.then((response) => {
				console.log(response);
				setUserData(response);
				setLoading(false);
			})
			.catch((error) => {
				console.log(error);
			});
	}

	useEffect(() => {
		fetchUser();
	}, []);

	return (
		<Box sx={{ width: "100%" }}>
			{!loading ? (
				<Stack spacing={2} sx={{ width: "100%" }}>
					<Typography
						sx={{
							fontSize: "20px",
							fontWeight: "700",
							color: ColorScheme.textSecondary,
						}}
					>{t("login.modify_info")}</Typography>

					<TextField
						placeholder={t("login.name")}
						sx={{
							backgroundColor: ColorScheme.transparent,
							borderRadius: "5px",
							fontSize: "10px"
						}}
						id="name"
						variant="outlined"
						margin="dense"
						type="text"
						fullWidth={true}
						size="small"
						error={regex("name", userData.name)}
						value={userData.name}
						onChange={(e) => modifyUserData("name", e.target.value)}
						InputLabelProps={{ style: { fontSize: 40 } }}
					/>
					<TextField
						placeholder={t("login.phone")}
						sx={{
							backgroundColor: ColorScheme.transparent,
							borderRadius: "5px",
							fontSize: "10px"
						}}
						id="phone"
						variant="outlined"
						margin="dense"
						fullWidth={true}
						size="small"
						value={userData.phone}
						error={regex("phone", userData.phone)}
						onChange={(e) =>
							modifyUserData("phone", e.target.value)
						}
						InputLabelProps={{ style: { fontSize: 40 } }}
					/>
					<TextField
						placeholder={t("login.license_plate")}
						sx={{
							backgroundColor: ColorScheme.transparent,
							borderRadius: "5px",
							fontSize: "10px"
						}}
						id="license_plate"
						variant="outlined"
						margin="dense"
						fullWidth={true}
						error={regex("license_plate", userData.license_plate)}
						size="small"
						value={userData.license_plate}
						onChange={(e) =>
							modifyUserData("license_plate", e.target.value)
						}
						InputLabelProps={{ style: { fontSize: 40 } }}
					/>

					<TextField
						placeholder={t("login.new_password")}
						sx={{
							backgroundColor: ColorScheme.transparent,
							borderRadius: "5px",
							fontSize: "10px"
						}}
						id="password"
						variant="outlined"
						margin="dense"
						fullWidth={true}
						size="small"
						value={newPass}
						type="password"
						onChange={(e) => setNewPass(e.target.value)}
						InputLabelProps={{ style: { fontSize: 40 } }}
						error={regex("password", newPass)}
						InputProps={{
							endAdornment: (
								<InputAdornment
									position="end"
									disablePointerEvents
								>
									<img src={passwordIcon} />
								</InputAdornment>
							)
						}}
					/>

					<BigButton
						action={HandleUpdate}
						backgroundColor={ColorScheme.buttonPrimary}
						textColor={ColorScheme.secondary}
						text={t("buttons.save")}
						activity={saving}
					/>
				</Stack>
			) : (
				<Spinner color={ColorScheme.secondary}/>
			)}
		</Box>
	);
};
